module.exports = __webpack_public_path__ + "static/binder6-dd53f4d9fd58404a594892dbde890c32.png";